import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * Groupe de lignes `vw-list-row` sous un titre, comme dans les réglages d'un
 * téléphone (PC-10) : une carte à plat, un filet entre les lignes. Le titre est
 * un `<h2>` : le lecteur d'écran passe d'un groupe à l'autre par les titres.
 * `edge="inset"` trace le filet du contour en ombre intérieure au lieu d'une
 * bordure : la carte garde sa hauteur au pixel près (bande météo et lune de
 * l'accueil, 117 px).
 * Usage : `<vw-list-section [title]="'profile.groups.garden' | translate">…</vw-list-section>`
 */
@Component({
  selector: 'vw-list-section',
  standalone: true,
  template: `
    <section>
      @if (title) {
        <h2 class="px-1 pb-2 text-title-s text-vw-ink">{{ title }}</h2>
      }
      <div class="overflow-hidden rounded-card bg-vw-surface divide-y divide-vw-line"
        [class]="edge === 'inset' ? 'ring-1 ring-inset ring-vw-line' : 'border border-vw-line'">
        <ng-content></ng-content>
      </div>
    </section>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ListSectionComponent {
  /** Texte déjà traduit. */
  @Input() title = '';
  /** Contour : `border` (1 px de chaque côté, par défaut) ou `inset` (ombre intérieure, sans place prise). */
  @Input() edge: 'border' | 'inset' = 'border';
}
